import { AccountsError } from '@flexible-reports/store/api/accounts/types';

export enum ReportFailureCode {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  AUTH_ACCOUNT_ACCESS_REVOKED = 'AUTH_ACCOUNT_ACCESS_REVOKED',
  PARTIAL_AUTH_ACCOUNT_ACCESS_REVOKED = 'PARTIAL_AUTH_ACCOUNT_ACCESS_REVOKED'
}

export enum FlexibleReport4xxErrorCodes {
  NAME_ALREADY_EXISTS = 'NAME_ALREADY_EXISTS',
  TOO_MANY_RECURRING_REPORTS = 'TOO_MANY_RECURRING_REPORTS',
  INVALID_METRIC_COMBINATION = 'INVALID_METRIC_COMBINATION',
  REPORT_TOO_LARGE = 'REPORT_TOO_LARGE',
  TOO_MANY_SELECTIONS = 'TOO_MANY_SELECTIONS',
  INVALID_DATE_RANGE = 'INVALID_DATE_RANGE',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  NOT_FOUND = 'NOT_FOUND',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  NO_RESOLVED_ACCOUNTS = 'NO_RESOLVED_ACCOUNTS',
  UNKNOWN = 'UNKNOWN'
}

export enum FlexibleReport5xxErrorCodes {
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR'
}

export type FlexibleReportError = FlexibleReport4xxErrorCodes | FlexibleReport5xxErrorCodes | ReportFailureCode | AccountsError | null;
